<template>
  <div class="Progressbar">
    <div class="ProgressbarContainer">
      <div class="ProgressbarIndicator" :style="style"></div>
    </div>
    <div class="ProgressbarText">Topic progress: {{ progress }}%</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Progressbar",
  computed: {
    ...mapGetters(["getQuestions", "getCompletedList"]),
    progress() {
      if (!this.getQuestions) {
        return 0;
      } else {
        return Math.ceil(
          (100 / this.getQuestions.length) * this.getCompletedList.length
        );
      }
    },
    style() {
      return { width: `${this.progress}%`, transition: "width 0.4s" };
    },
  },
};
</script>

<style lang="scss" scoped>
.Progressbar {
  .ProgressbarContainer {
    display: flex;
    align-items: center;
    width: 500px;
    height: 20px;
    padding: 0 4px;
    margin-bottom: 10px;
    box-sizing: border-box;
    border: 1px solid $color-light-grey;
    border-radius: 30px;
    .ProgressbarIndicator {
      width: 260px;
      height: 12px;
      border-radius: 30px;
      background-color: $color-blue;
    }
  }
  .ProgressbarText {
    font-size: 14px;
    color: $color-grey;
  }
}

@media screen and (max-width: 650px) {
  .Progressbar {
    width: 100%;
    .ProgressbarContainer {
      width: 100%;
    }
  }
}
</style>
